import { render } from "./VendorListItem.vue?vue&type=template&id=110648ac&scoped=true&ts=true"
import script from "./VendorListItem.vue?vue&type=script&lang=ts"
export * from "./VendorListItem.vue?vue&type=script&lang=ts"

import "./VendorListItem.vue?vue&type=style&index=0&id=110648ac&scoped=true&lang=scss"

import exportComponent from "/home/gui/adm/gpp-cmp/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-110648ac"]])

export default __exports__